import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import { addReviewReducer } from 'features/addReview/addReview.slice';
import { calculationReducer } from 'features/calculation/calculation.slice';
import { callbackReducer } from 'features/callback/callback.slice';
import { commonReducer } from 'features/common/common.slice';
import { hotelReducer } from 'features/hotel/hotel.slice';
import { questionReducer } from 'features/question/question.slice';
import { quizReducer } from 'features/quiz/quiz.slice';
import { ratingReducer } from 'features/rating/rating.slice';
import { reviewReducer } from 'features/review/review.slice';

export const store = configureStore({
  reducer: {
    common: commonReducer,
    callback: callbackReducer,
    calculation: calculationReducer,
    review: reviewReducer,
    addReview: addReviewReducer,
    question: questionReducer,
    quiz: quizReducer,
    hotel: hotelReducer,
    rating: ratingReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
